var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowBackIos = function SvgArrowBackIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow_back_ios_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h19v19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_back_ios_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "m2.522 9.5 5.963 5.964a.74.74 0 0 1 .23.556.78.78 0 0 1-.242.555.76.76 0 0 1-.555.236.76.76 0 0 1-.556-.236l-6.073-6.06a1.4 1.4 0 0 1-.318-.482 1.5 1.5 0 0 1-.104-.532q0-.267.104-.533.104-.267.318-.481l6.073-6.073a.75.75 0 0 1 .562-.23.8.8 0 0 1 .561.242.76.76 0 0 1 .236.555.76.76 0 0 1-.236.556z"
  }))));
};
export default SvgArrowBackIos;